import { render } from "./SidebarMenuSubButton.vue?vue&type=template&id=d52ed840&ts=true"
import script from "./SidebarMenuSubButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuSubButton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarMenuSubButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d52ed840"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d52ed840', __exports__)) {
    api.reload('d52ed840', __exports__)
  }
  
  module.hot.accept("./SidebarMenuSubButton.vue?vue&type=template&id=d52ed840&ts=true", () => {
    api.rerender('d52ed840', render)
  })

}


export default __exports__